import React from 'react';
import { connect } from 'react-redux';

import { ItemCatalog } from 'components/ProductItem';

const List = ({
    isListMode,
    catalogProducts,
    catalogProductsLength,
    isLoading
}) => (
    <ul className={isListMode ? 'catalogList--list' : 'catalogList--grid'}>
        {catalogProductsLength > 0 ? (
            catalogProducts.map(product => {
                let productImage = '';
                let productDescription = '';
                product.custom_attributes.map(attribute => {
                    if (attribute.attribute_code === 'small_image')
                        productImage = attribute.value;
                    if (attribute.attribute_code === 'description')
                        productDescription = attribute.value;
                    return true;
                });
                return (
                    <ItemCatalog
                        key={product.sku}
                        product={product}
                        productImage={productImage}
                        productDescription={productDescription}
                    />
                );
            })
        ) : !isLoading ? (
            <div className="empty">No products found. Please try again.</div>
        ) : null}
    </ul>
);

const mapStateToProps = state => {
    const { isListMode } = state.catalogReducer;

    return {
        isListMode: isListMode
    };
};

export default connect(mapStateToProps)(List);



// WEBPACK FOOTER //
// ./src/modules/Catalog/components/List.jsx